export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sidebar.vue?vue&type=template&id=874dd30a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/Sidebar.vue?vue&type=template&id=874dd30a&
// module id = null
// module chunks = 